import axiosInstance from '../../common/axios.service';
import {ASSIGN_BATTERY, INETERNAL_SWAP, REASSIGN_BATTERY, SWAP_INIT} from './rackScreen.types';

const rackData = (payload: {station_id: number; rack_id: number}) => {
  return axiosInstance.get('dashboard/rackscreendata', {params: payload}).then((response) => {
    return response;
  });
};

const assignBattery = (values: ASSIGN_BATTERY) => {
  return axiosInstance.post('customer/assignbattery', values).then((response) => {
    return response;
  });
};

const reAssignBattery = (values: REASSIGN_BATTERY) => {
  return axiosInstance.post('customer/reassignbattery', values).then((response) => {
    return response;
  });
};

const swapInitialize = (values: SWAP_INIT) => {
  return axiosInstance.post('swap/initialize', values).then((response) => {
    return response;
  });
};

const internalSwap = (data: {values: INETERNAL_SWAP; rackId: number}) => {
  return axiosInstance
    .post(`/swap/changebatteries/${data.rackId}`, data.values)
    .then((response) => {
      return response;
    });
};

const submitBattery = (data: {rack_id: number; station_id: number}) => {
  return axiosInstance.post(`/swap/terminatecustomer`, data).then((response) => {
    return response;
  });
};

const rackScreenService = {
  rackData,
  swapInitialize,
  internalSwap,
  assignBattery,
  reAssignBattery,
  submitBattery,
};

export default rackScreenService;
